import { render } from "./SalarySettings.vue?vue&type=template&id=08556f66"
import script from "./SalarySettings.vue?vue&type=script&lang=js"
export * from "./SalarySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__